if (!customElements.get('product-sticky-bar')) {
  class ProductStickyBar extends HTMLElement {
    constructor() {
      super();
      
      this.stickyBar = document.querySelector('[data-product-sticky-bar]');
      if (!this.stickyBar) return;
      
      this.imageContainer = this.stickyBar.querySelector('[data-sticky-image]');
      this.priceElement = this.stickyBar.querySelector('[data-sticky-price]');
      this.form = document.querySelector('product-form-update') || document.querySelector('product-form');
      this.formElement = document.querySelector('product-form-update form') || document.querySelector('product-form form');
      
      const variantImagesElement = document.getElementById('variant-images-data') || 
                                   document.getElementById('variant-images-data-black-friday');
      this.variantImagesData = variantImagesElement 
        ? JSON.parse(variantImagesElement.innerHTML)
        : {};
      
      this.init();
    }
    
    init() {
      document.addEventListener('variant:change', (e) => {
        this.updateImage(e.detail.variant);
        this.updatePrice(e.detail.variant);
      });
      
      this.handleScroll();
      window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
      
      const button = this.stickyBar.querySelector('.product-sticky-bar--button');
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.formElement) {
            this.formElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    }
    
    handleScroll() {
      if (!this.formElement) return;
      
      const formRect = this.formElement.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Show sticky bar when form is not visible in viewport
      const formNotVisible = formRect.bottom < 0 || formRect.top > windowHeight;
      
      if (formNotVisible) {
        this.stickyBar.classList.add('visible');
      } else {
        this.stickyBar.classList.remove('visible');
      }
    }
    
    updateImage(variant) {
      if (!this.imageContainer || !variant) return;
      
      const variantId = String(variant.id);
      let imageToUse = null;
      
      if (this.variantImagesData && this.variantImagesData[variantId] && this.variantImagesData[variantId].length > 0) {
        imageToUse = this.variantImagesData[variantId][0];
      } 
      else {
        const productMedia = document.querySelector('[data-product-media]');
        if (productMedia) {
          const slides = productMedia.querySelectorAll('.swiper-slide[data-default-media="true"]');
          for (const slide of slides) {
            const variants = slide.dataset.variants ? JSON.parse(slide.dataset.variants) : null;
            if (variants && variants.includes(Number(variantId))) {
              const img = slide.querySelector('img');
              if (img && img.src) {
                imageToUse = {
                  src: img.src,
                  alt: img.alt || variant.title
                };
                break;
              }
            }
          }
        }
      }
      
      if (imageToUse) {
        const img = this.imageContainer.querySelector('img');
        if (img) {
          img.src = imageToUse.src;
          if (imageToUse.alt) {
            img.alt = imageToUse.alt;
          }
          
          const widths = [68, 136];
          const srcset = widths.map(width => {
            const srcWithWidth = this.appendQueryToShopifyImageUrl(imageToUse.src, `${width}x`);
            return `${srcWithWidth} ${width}w`;
          }).join(', ');
          img.srcset = srcset;
        }
      }
    }
    
    updatePrice(variant) {
      if (!this.priceElement || !variant || !this.form) return;
      
      const formComponent = this.form;
      const currentVariant = formComponent.currentVariant;
      
      let price = currentVariant.price;
      
      if (formComponent.hasSubscription && formComponent.currentSubscription) {
        price = formComponent.currentSubscription.price;
      } else if (currentVariant.selling_plans && currentVariant.selling_plans.length > 0) {
        price = currentVariant.selling_plans[0].price;
      }
      
      const formattedPrice = window.formatMoney ? window.formatMoney(price) : `$${(price / 100).toFixed(2)}`;
      this.priceElement.textContent = `Add to Cart - from ${formattedPrice}`;
    }
    
    appendQueryToShopifyImageUrl(url, query) {
      const urlParts = url.split('?');
      const baseUrl = urlParts[0];
      const queryString = urlParts[1] || '';
      
      const extensionMatch = baseUrl.match(/\.(jpg|jpeg|png|webp|gif|bmp|tiff)$/i);
      if (!extensionMatch) {
        return url;
      }
      
      const extensionIndex = extensionMatch.index;
      const modifiedBaseUrl = `${baseUrl.slice(0, extensionIndex)}_${query}${baseUrl.slice(extensionIndex)}`;
      
      return queryString ? `${modifiedBaseUrl}?${queryString}` : modifiedBaseUrl;
    }
  }
  
  customElements.define('product-sticky-bar', ProductStickyBar);
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ProductStickyBar();
    });
  } else {
    new ProductStickyBar();
  }
}

